<dx-popup
  [width]="900"
  [height]="'auto'"
  [showTitle]="true"
  [title]="dialogTitle"
  [(visible)]="displayDialog"
  [resizeEnabled]="true"
  (onHiding)="closeDialog()"
>
  <form (ngSubmit)="save()" [formGroup]="form">
    <div class="p-2 row mg-t-10">
      <div class="col-md-4 genlabel required">Site <span class="danger-color">*</span></div>
      <div *ngIf="canModify(); else elseBlock" class="col-md-8">
        <dx-lookup
          [value]="siteSelected?.id"
          [items]="sitesList"
          formControlName="site"
          placeholder="Sélectionner un site"
          valueExpr="id"
          displayExpr="libelle"
          searchExpr="libelle"
        >
        </dx-lookup>
      </div>
      <ng-template #elseBlock>
        <div class="col-md-8">
          <yo-site [siteLibelle]="seuil.site?.libelle"
                   [siteId]="seuil.site?.id"></yo-site>
        </div>
      </ng-template>
    </div>

    <div class="p-2 row mg-t-10">
      <div class="col-md-4 genlabel required">Libellé <span class="danger-color">*</span></div>
      <div class="col-md-8">
        <div class="input-group-sm">
          <dx-text-box [disabled]="!canModify()" placeholder="Température des frigos"
                       formControlName="libelle"></dx-text-box>
          <ng-container
            *ngTemplateOutlet="tplError;context:{form:form,property:'libelle',label:'Libellé'}"></ng-container>
        </div>
      </div>
    </div>

    <div class="p-2 row mg-t-10">
      <div class="col-md-4 genlabel required">Minimum</div>
      <div class="col-md-8">
        <div class="input-group-sm">
          <dx-number-box [disabled]="!canModify()" placeholder="0" formControlName="min"></dx-number-box>
          <ng-container
            *ngTemplateOutlet="tplError;context:{form:form,property:'min',label:'Minimum'}"></ng-container>
        </div>
      </div>
    </div>

    <div class="p-2 row mg-t-10">
      <div class="col-md-4 genlabel required">Maximum</div>
      <div class="col-md-8">
        <div class="input-group-sm">
          <dx-number-box [disabled]="!canModify()" placeholder="0" formControlName="max"></dx-number-box>
          <ng-container
            *ngTemplateOutlet="tplError;context:{form:form,property:'max',label:'Maximum'}"></ng-container>
        </div>
      </div>
    </div>

    <div class="p-2 row mg-t-10">
      <div class="col-md-4 genlabel required">Unité <span class="danger-color">*</span></div>
      <div class="col-md-8">
        <div class="dx-field">
          <dx-lookup
            [value]="uniteSelected?.id"
            [dataSource]="unitesDataSource"
            formControlName="unite"
            placeholder="Sélectionner une unité"
            valueExpr="id"
            displayExpr="libelle"
            [searchEnabled]="false"
            [disabled]="!canModify()"
          >
          </dx-lookup>
        </div>
      </div>
    </div>

    <div class="p-2 row mg-t-10">
      <div class="col-md-4 genlabel required">Couleur <span class="danger-color">*</span></div>
      <div class="col-md-8">
        <dx-color-box
          [(ngModel)]="couleurSelected"
          [disabled]="!canModify()"
          formControlName="couleur"
        ></dx-color-box>
        <ng-container
          *ngTemplateOutlet="tplError;context:{form:form,property:'couleur',label:'Couleur'}"></ng-container>
      </div>
    </div>

    <div class="p-2 row mg-t-10">
      <div class="col-md-4 genlabel required">Icône <span class="danger-color">*</span></div>
      <div class="col-md-8">
        <div class="dx-field">
          <dx-lookup
            class="field-customization"
            height="auto"
            [value]="iconPath"
            [items]="imagesPath"
            formControlName="icone"
            itemTemplate="listItem"
            fieldTemplate="field"
            [searchEnabled]="false"
            [disabled]="!canModify()"
            (valueChange)="updateIcon($event)"
          >
            <div *dxTemplate="let item of 'listItem'">
              <div class="custom-field">
                <img src="{{ item?.path }}" style="width: 25px" alt=""/>
              </div>
            </div>
            <div *dxTemplate="let item of 'field'">
              <div class="custom-field" *ngIf="iconPath">
                <img src="{{ iconPath?.path }}" style="width: 25px" alt=""/>
              </div>
              <div *ngIf="!iconPath" class="dx-lookup-field-wrapper dx-lookup-empty">
                <div class="dx-lookup-field">
                  Sélectionner une icône
                </div>
              </div>
            </div>
          </dx-lookup>
        </div>
      </div>
    </div>

    <div class="p-2 row mg-t-10">
      <div class="col-md-4 genlabel required">Description <span class="danger-color">*</span></div>
      <div class="col-md-8">
        <div class="input-group-sm">
          <dx-text-box [disabled]="!canModify()" placeholder="Frigo" formControlName="description"></dx-text-box>
          <ng-container
            *ngTemplateOutlet="tplError;context:{form:form,property:'description',label:'Description'}"></ng-container>
        </div>
      </div>
    </div>

    <div class="p-2 d-flex justify-content-end">
      <yo-button
        type="submit"
        title="Enregistrer"
        iconClass="fas fa-save"
        [theme]="ButtonThemeEnum.SAVE"
        [disabled]="!canModify()"
        [class.disable]="!canModify()">
      </yo-button>
      <yo-button
        class="ml-3"
        title="Fermer"
        iconClass="fas fa-times"
        [theme]="ButtonThemeEnum.CANCEL"
        (click)="closeDialog()"
      >
      </yo-button>
    </div>
  </form>
</dx-popup>

<ng-template #tplError let-form="form" let-property="property" let-label="label">
  <div class="error"
       *ngIf="form.controls[property].invalid && (form.controls[property].dirty || form.controls[property].touched )">

    <pre>{{form.controls[property].validators | json}}</pre>

    <div class="pg-2" *ngIf="form.controls[property].hasError('required')">
      Le champ {{label}} est obligatoire.
    </div>
    <div class="pg-2" *ngIf="form.controls[property].hasError('minlength')">
      Le champ {{label}} ne peut avoir moins de {{form.controls[property].errors.minlength.requiredLength}} caractères.
    </div>
    <div class="pg-2" *ngIf="form.controls[property].hasError('maxlength')">
      Le champ {{label}} ne doit pas dépasser {{form.controls[property].errors.maxlength.requiredLength}} caractères.
    </div>

  </div>

</ng-template>
